import React from 'react';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import "animate.css/animate.min.css";
import './ConceptoVideo.scss';
import { useTranslation, Trans } from 'react-i18next';

// Swiper v6/v7
import SwiperCore, { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

// Estilos de Swiper
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

SwiperCore.use([Navigation, Pagination]);

const videos = [
  { src: '/assets/Video/1.mp4', title: 'Video 1' },
  { src: '/assets/Video/2.mp4', title: 'Video 2' },
  { src: '/assets/Video/3.mp4', title: 'Video 3' },
  { src: '/assets/Video/4.mp4', title: 'Video 4' },
];

const ConceptoVideo = (props) => {
  const { t } = useTranslation();

  const handleVideo = () => {
    props.setVideo(true);
    props.setUrlVideo("U1pR-yp3ajY");
  };

  return (
    <div id="concepto" className='contenedor_video'>
      <div className='contenedor_video__left'>
        <AnimationOnScroll
          duration={2}
          animateOnce={true}
          animateIn='animate__fadeIn'>
          <div className='contenedor_video__left_subtitulo'>
            <h2>{t('conceptoVideo.title')}</h2>
          </div>
        </AnimationOnScroll>
        <div className='contenedor_video__left_texto'>
          <p>
            <Trans
              i18nKey="conceptoVideo.description"
              components={{ bold: <strong /> }}
            />
          </p>
        </div>
        <div className='contenedor_video__left_button'>
          <a href='/#masterplan'>{t('conceptoVideo.availability')}</a>
        </div>
      </div>
      <div className='contenedor_video__right'>
              <div className='contenedor_video__right_video'>
                <Swiper
                  spaceBetween={16}
                  slidesPerView={1}
                  loop={true}
                  navigation={true}
                  pagination={{ clickable: true }}
                  className="mySwiper"
                >
                  {videos.map((video, index) => (
                    <SwiperSlide key={index}>
                      <div className="video_slide">
                        <video
                          src={video.src}
                          controls
                          autoPlay
                          muted
                          loop
                          playsInline
                          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        />
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
     
    </div>
  );
};

export default ConceptoVideo;
